// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__2cQpN","header":"ReportDetails_header__2j6vk","title":"ReportDetails_title__Nls0x","left":"ReportDetails_left__2jGfc"};